// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__6SyYI","text":"Footer_text__0NzSg"};